import { Directive, Input } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';

import { validateFurnitureTotalPrice } from '@shared/common/form-validators';


@Directive({
  selector: '[appFurnitureTotalPriceValidator]',
  standalone: true,
})
export class FurnitureTotalPriceValidatorDirective {
  @Input() formControl: FormControl;

  @Input() set appFurnitureTotalPriceValidator(planUpTo: number) {
    if (this.formControl) {
      this.formControl.setValidators(
        Validators.compose([
          Validators.required,
          Validators.maxLength(100),
          validateFurnitureTotalPrice(planUpTo),
        ]),
      );
      this.formControl.updateValueAndValidity();
    }
  }
}
